import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getDetailHistory = async (
  e_line,
  cur_page,
  fr_date,
  to_date,
  bsd_sttus_id,
) => {
  const requestBody = {
    e_line,
    cur_page,
    fr_date,
    to_date,
    bsd_sttus_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/bsdStatusHistory`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};
